import TakeoutSVG from "@design-system/ui-icons/vanilla/Takeout"
import { createIcon } from "../createIcon"

export const TakeoutIcon = createIcon(TakeoutSVG)
